/** Dados e helpers do mock “Controle de Kit de Peças” (frontend only). */

export const CATALOGO = [
  { cod: 'BSC-0421', ref: 'F002H50086', nome: 'Bomba de combustível', fab: 'Bosch' },
  { cod: 'NGK-1180', ref: 'BKR6E-11', nome: 'Vela de ignição', fab: 'NGK' },
  { cod: 'MHL-3302', ref: 'PC-3302', nome: 'Filtro de óleo', fab: 'Mahle' },
  { cod: 'CBQ-7714', ref: 'N-7714', nome: 'Pastilha de freio', fab: 'Cobreq' },
  { cod: 'MGM-2205', ref: 'RD-2205', nome: 'Relé de partida', fab: 'Magneti Marelli' },
  { cod: 'SKF-5590', ref: 'VKBA-5590', nome: 'Rolamento de roda', fab: 'SKF' },
  { cod: 'BSC-9077', ref: '0986AB1234', nome: 'Sensor de rotação', fab: 'Bosch' },
  { cod: 'GTS-4410', ref: 'GT-4410', nome: 'Correia dentada', fab: 'Gates' },
];

/** itens: [indiceCatalogo, qtdKit, estoque, prontasColeta, pedido] */
export function kitsSeed() {
  return [
    {
      id: 1,
      nome: 'Carlos Menezes',
      coord: 'Fernanda Alves',
      area: 'Zona Sul',
      veiculo: 'Fiorino · PLK-4C12',
      ultimaColeta: '04/08 · CD Santo Amaro',
      ultimoUso: 'Hoje 09:41 · OS 88214',
      itens: [
        [0, 2, 1, 1, 'PED-90412'],
        [1, 6, 4, 2, 'PED-90412'],
        [2, 4, 4, 0, ''],
        [3, 4, 2, 0, ''],
        [5, 2, 2, 0, ''],
        [6, 2, 1, 0, ''],
        [7, 2, 2, 0, ''],
      ],
    },
    {
      id: 2,
      nome: 'Rafael Lima',
      coord: 'Fernanda Alves',
      area: 'Zona Leste',
      veiculo: 'Moto CG 160 · QRT-8H44',
      ultimaColeta: '28/07 · CD Penha',
      ultimoUso: 'Ontem 16:02 · OS 88109',
      itens: [
        [0, 2, 0, 2, 'PED-90388'],
        [1, 6, 3, 3, 'PED-90388'],
        [2, 4, 2, 0, ''],
        [3, 4, 1, 2, 'PED-90401'],
        [6, 2, 1, 0, ''],
        [7, 2, 2, 0, ''],
      ],
    },
    {
      id: 3,
      nome: 'Diego Farias',
      coord: 'Rodrigo Prado',
      area: 'Centro',
      veiculo: 'Saveiro · GHT-2B09',
      ultimaColeta: '06/08 · CD Sé',
      ultimoUso: '03/08 · OS 87960',
      itens: [
        [0, 2, 3, 0, ''],
        [1, 6, 8, 0, ''],
        [2, 4, 4, 0, ''],
        [3, 4, 5, 0, ''],
        [4, 2, 2, 0, ''],
        [5, 2, 3, 0, ''],
        [7, 2, 2, 0, ''],
      ],
    },
    {
      id: 4,
      nome: 'Marcos Vieira',
      coord: 'Rodrigo Prado',
      area: 'ABC',
      veiculo: 'Moto Fazer 250 · LTS-9J20',
      ultimaColeta: '12/07 · CD São Bernardo',
      ultimoUso: '05/08 · OS 88033',
      itens: [
        [0, 2, 0, 0, ''],
        [1, 6, 0, 6, 'PED-90355'],
        [2, 4, 0, 4, 'PED-90355'],
        [3, 4, 0, 0, ''],
        [6, 2, 0, 0, ''],
        [7, 2, 0, 0, ''],
      ],
    },
    {
      id: 5,
      nome: 'Patrícia Nunes',
      coord: 'Fernanda Alves',
      area: 'Zona Norte',
      veiculo: 'Kangoo · MRC-5F71',
      ultimaColeta: '05/08 · CD Tucuruvi',
      ultimoUso: 'Hoje 08:15 · OS 88220',
      itens: [
        [0, 2, 2, 0, ''],
        [1, 6, 5, 1, 'PED-90430'],
        [2, 4, 4, 0, ''],
        [3, 4, 4, 0, ''],
        [4, 2, 1, 0, ''],
        [5, 2, 2, 0, ''],
        [6, 2, 2, 0, ''],
        [7, 2, 2, 0, ''],
      ],
    },
    {
      id: 6,
      nome: 'Ana Ribeiro',
      coord: 'Rodrigo Prado',
      area: 'Zona Oeste',
      veiculo: 'Fiorino · JKD-1A88',
      ultimaColeta: '07/08 · CD Lapa',
      ultimoUso: 'Hoje 10:20 · OS 88231',
      itens: [
        [0, 2, 2, 0, ''],
        [1, 6, 6, 0, ''],
        [2, 4, 4, 0, ''],
        [3, 4, 4, 0, ''],
        [5, 2, 2, 0, ''],
        [7, 2, 2, 0, ''],
      ],
    },
    {
      id: 7,
      nome: 'Juliana Costa',
      coord: 'Fernanda Alves',
      area: 'Centro',
      veiculo: 'Moto Biz 125 · PWR-3C55',
      ultimaColeta: '06/08 · CD Sé',
      ultimoUso: 'Ontem 14:48 · OS 88187',
      itens: [
        [0, 2, 2, 0, ''],
        [1, 6, 6, 0, ''],
        [2, 4, 4, 0, ''],
        [3, 4, 4, 0, ''],
        [6, 2, 2, 0, ''],
      ],
    },
    {
      id: 8,
      nome: 'Bruno Tavares',
      coord: 'Rodrigo Prado',
      area: 'ABC',
      veiculo: 'Saveiro · TQN-7D31',
      ultimaColeta: '05/08 · CD São Bernardo',
      ultimoUso: '04/08 · OS 88001',
      itens: [
        [0, 2, 2, 0, ''],
        [1, 6, 6, 0, ''],
        [2, 4, 4, 0, ''],
        [3, 4, 4, 0, ''],
        [4, 2, 2, 0, ''],
        [7, 2, 2, 0, ''],
      ],
    },
  ];
}

export function semKitSeed() {
  return [
    { id: 101, nome: 'Everton Sales', coord: 'Rodrigo Prado', area: 'Zona Leste', veiculo: 'Moto CG 160' },
    { id: 102, nome: 'Tatiane Moraes', coord: 'Fernanda Alves', area: 'Zona Norte', veiculo: 'Fiorino' },
    { id: 103, nome: 'Wesley Andrade', coord: 'Rodrigo Prado', area: 'ABC', veiculo: 'Moto Fazer 250' },
    { id: 104, nome: 'Camila Prado', coord: 'Fernanda Alves', area: 'Zona Sul', veiculo: 'Kangoo' },
  ];
}

export const MOVS_SEED = {
  1: [
    ['saida', 0, 1, 'Auto Center Ipiranga', 'OS 88214 · PED-88214-A', 'Hoje 09:41'],
    ['saida', 3, 2, 'Transportes Vega', 'OS 88190 · PED-88190-B', 'Ontem 15:12'],
    ['entrada', 1, 4, 'Coleta CD Santo Amaro', 'PED-90201', '04/08 11:03'],
    ['saida', 6, 1, 'Padaria São Jorge', 'OS 88151 · PED-88151-A', '03/08 17:26'],
    ['entrada', 2, 2, 'Coleta CD Santo Amaro', 'PED-90112', '01/08 09:40'],
    ['saida', 1, 2, 'Mercado Bom Preço', 'OS 88044 · PED-88044-C', '31/07 13:55'],
  ],
  2: [
    ['saida', 0, 2, 'Frota Delta Log', 'OS 88109 · PED-88109-A', 'Ontem 16:02'],
    ['saida', 3, 3, 'Condomínio Aurora', 'OS 88087 · PED-88087-A', '05/08 10:31'],
    ['entrada', 2, 2, 'Coleta CD Penha', 'PED-90044', '28/07 08:52'],
    ['saida', 1, 3, 'Oficina Central Leste', 'OS 87991 · PED-87991-B', '27/07 14:10'],
  ],
  3: [
    ['entrada', 1, 4, 'Coleta CD Sé', 'PED-90350', '06/08 09:12'],
    ['entrada', 3, 3, 'Coleta CD Sé', 'PED-90350', '06/08 09:12'],
    ['saida', 5, 1, 'Hotel Marabá', 'OS 87960 · PED-87960-A', '03/08 11:44'],
  ],
  4: [
    ['saida', 1, 4, 'Distribuidora Norte', 'OS 88033 · PED-88033-A', '05/08 15:20'],
    ['saida', 2, 4, 'Distribuidora Norte', 'OS 88033 · PED-88033-A', '05/08 15:20'],
    ['saida', 0, 2, 'Clínica Vida', 'OS 87902 · PED-87902-C', '29/07 09:05'],
    ['entrada', 1, 6, 'Coleta CD São Bernardo', 'PED-89801', '12/07 08:30'],
  ],
  5: [
    ['saida', 1, 1, 'Colégio Santa Rita', 'OS 88220 · PED-88220-A', 'Hoje 08:15'],
    ['saida', 4, 1, 'Supermercado Ideal', 'OS 88175 · PED-88175-B', '05/08 16:40'],
    ['entrada', 2, 2, 'Coleta CD Tucuruvi', 'PED-90310', '05/08 08:05'],
  ],
  6: [
    ['saida', 1, 1, 'Farmácia Nova', 'OS 88231 · PED-88231-A', 'Hoje 10:20'],
    ['entrada', 1, 2, 'Coleta CD Lapa', 'PED-90402', '07/08 08:10'],
  ],
  7: [
    ['saida', 2, 1, 'Restaurante Dom', 'OS 88187 · PED-88187-A', 'Ontem 14:48'],
    ['entrada', 2, 1, 'Coleta CD Sé', 'PED-90361', '06/08 09:30'],
  ],
  8: [
    ['saida', 3, 2, 'Auto Posto Sul', 'OS 88001 · PED-88001-B', '04/08 13:22'],
    ['entrada', 3, 2, 'Coleta CD São Bernardo', 'PED-90280', '05/08 08:44'],
  ],
};

export const PEDIDOS_SEED = {
  1: [{ numero: 'PED-90412', data: '07/08', local: 'CD Santo Amaro', status: 'Pronto p/ coleta', itens: [[0, 1], [1, 2]] }],
  2: [
    { numero: 'PED-90388', data: '06/08', local: 'CD Penha', status: 'Pronto p/ coleta', itens: [[0, 2], [1, 3]] },
    { numero: 'PED-90401', data: '07/08', local: 'CD Penha', status: 'Separando', itens: [[3, 2]] },
  ],
  4: [{ numero: 'PED-90355', data: '05/08', local: 'CD São Bernardo', status: 'Pronto p/ coleta', itens: [[1, 6], [2, 4]] }],
  5: [{ numero: 'PED-90430', data: '07/08', local: 'CD Tucuruvi', status: 'Pronto p/ coleta', itens: [[1, 1]] }],
};

export const CORES_SIT = {
  completo: { cor: '#12a06a', fundo: '#e7f6ee', label: 'Kit completo' },
  excesso: { cor: '#2d6df6', fundo: '#eaf1ff', label: 'Kit com excesso' },
  pendencias: { cor: '#d98207', fundo: '#fdf3e3', label: 'Kit com pendências' },
  zerado: { cor: '#d64533', fundo: '#fdecea', label: 'Kit zerado' },
};

export const PALETA = [
  ['#efeeff', '#5b5bd6'],
  ['#e7f6ee', '#0d7a4f'],
  ['#fdf3e3', '#a8620a'],
  ['#eaf1ff', '#1c4fbd'],
  ['#fdecea', '#b93b2b'],
  ['#f1f2f5', '#41475a'],
];

/** Kit padrão (catálogo completo com qtd mock). */
export function kitPadraoItens() {
  return CATALOGO.map((_, idx) => [idx, 2, 2, 0, '']);
}

export function calcKit(t) {
  const itens = (t.itens || []).map((r, i) => {
    if (r && typeof r === 'object' && !Array.isArray(r)) {
      return {
        idx: r.productCode || r.cod || i,
        cod: String(r.cod || r.productCode || '').trim(),
        ref: String(r.ref || r.reference || '').trim(),
        nome: String(r.nome || r.productName || r.product_name || '').trim(),
        fab: String(r.fab || r.manufacturer || '').trim() || '—',
        kit: Math.max(0, Number(r.kit ?? r.quantityMax ?? r.quantity_max) || 0),
        estoque: Math.max(0, Number(r.estoque ?? r.quantityCurrent ?? r.quantity_current) || 0),
        prontas: Math.max(0, Number(r.prontas) || 0),
        pedido: r.pedido || '',
      };
    }
    const c = CATALOGO[r[0]] || CATALOGO[0];
    return {
      idx: r[0],
      cod: c.cod,
      ref: c.ref,
      nome: c.nome,
      fab: c.fab,
      kit: r[1],
      estoque: r[2],
      prontas: r[3],
      pedido: r[4] || '',
    };
  });
  const totalKit = itens.reduce((s, i) => s + i.kit, 0);
  const temSobra = itens.some((i) => i.estoque > i.kit);
  const emEstoque = itens.reduce((s, i) => s + Math.min(i.estoque, i.kit), 0);
  const pct = totalKit ? Math.round((emEstoque / totalKit) * 100) : 0;
  const faltando = itens.reduce((s, i) => s + Math.max(0, i.kit - i.estoque), 0);
  const coletasFromItems = itens.reduce((s, i) => s + i.prontas, 0);
  const coletas = Math.max(coletasFromItems, Number(t.pickupReadyPieces) || 0);
  const pedidosSet = {};
  itens.forEach((i) => {
    if (i.pedido) pedidosSet[i.pedido] = 1;
  });
  const nPedidosFromItems = Object.keys(pedidosSet).length;
  const nPedidos = Math.max(nPedidosFromItems, Number(t.pickupReadyOrders) || 0);

  let sit = 'completo';
  if (emEstoque === 0) sit = 'zerado';
  else if (faltando > 0) sit = 'pendencias';

  const fabs = {};
  itens.forEach((i) => {
    if (!fabs[i.fab]) fabs[i.fab] = { fab: i.fab, kit: 0, est: 0 };
    fabs[i.fab].kit += i.kit;
    fabs[i.fab].est += i.estoque;
  });
  const desvios = Object.values(fabs)
    .filter((f) => f.est !== f.kit)
    .map((f) => {
      const p = f.kit ? Math.round((f.est / f.kit) * 100) : 0;
      const d = f.est - f.kit;
      const baixo = d < 0;
      const pontuados = itens
        .filter((i) => i.fab === f.fab && i.estoque !== i.kit)
        .map((i) => ({
          nome: i.nome || i.cod || '—',
          kit: i.kit,
          estoque: i.estoque,
        }))
        .sort((a, b) => Math.abs(b.estoque - b.kit) - Math.abs(a.estoque - a.kit) || a.nome.localeCompare(b.nome, 'pt'));
      return {
        fab: f.fab,
        pct: `${p}%`,
        delta: (d > 0 ? '+' : '') + d,
        cor: baixo ? '#c8412f' : '#2d6df6',
        fundo: baixo ? '#fdecea' : '#eaf1ff',
        borda: baixo ? '#f7d7d2' : '#dbe6fd',
        itens: pontuados,
      };
    })
    .sort((a, b) => parseInt(a.pct, 10) - parseInt(b.pct, 10));

  return {
    itens,
    totalKit,
    emEstoque,
    pct,
    faltando,
    temSobra,
    coletas,
    nPedidos,
    sit,
    desvios,
  };
}

function paletteIndex(id) {
  const s = String(id ?? '');
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h % PALETA.length;
}

export function viewTech(t) {
  const c = calcKit(t);
  const s = CORES_SIT[c.sit];
  const p = PALETA[paletteIndex(t.id ?? t.codtech)];
  const partes = String(t.nome || '').split(/\s+/).filter(Boolean);
  const iniciais =
    String(t.initials || '').trim() ||
    (partes.length >= 2
      ? (partes[0][0] + partes[partes.length - 1][0]).toUpperCase()
      : (partes[0] || '?').slice(0, 2).toUpperCase());
  let desvios = c.desvios;
  if (desvios.length > 3) {
    const extra = desvios.length - 3;
    const rest = desvios.slice(3);
    desvios = desvios.slice(0, 3).concat([
      {
        fab: `+${extra} ${extra === 1 ? 'fabricante' : 'fabricantes'}`,
        pct: '',
        delta: '',
        cor: '#8b91a0',
        fundo: '#f6f7f9',
        borda: '#e6e8ec',
        grouped: true,
        itens: rest.flatMap((d) => (d.itens || []).map((i) => ({ ...i, fab: d.fab }))),
      },
    ]);
  }
  return {
    ...t,
    ...c,
    iniciais,
    profilePhotoUrl: t.profilePhotoUrl || null,
    avatarBg: p[0],
    avatarCor: p[1],
    linha2: `${t.area || '—'} · ${t.coord || '—'}`,
    sitCor: s.cor,
    sitFundo: s.fundo,
    sitLabel: s.label,
    temSobra: c.temSobra,
    sobraCor: CORES_SIT.excesso.cor,
    sobraLabel: CORES_SIT.excesso.label,
    pctLabel: `${c.pct}%`,
    barra: `${Math.min(100, c.pct)}%`,
    barraExcesso: c.pct > 100 ? `${Math.min(30, c.pct - 100)}%` : '0%',
    corExcesso: '#93b4fb',
    temDesvios: c.desvios.length > 0,
    desvios,
    temColetas: c.coletas > 0,
    coletasLabel:
      `${c.coletas}${c.coletas === 1 ? ' peça pronta para coleta em ' : ' peças prontas para coleta em '}` +
      `${c.nPedidos}${c.nPedidos === 1 ? ' pedido' : ' pedidos'}`,
  };
}
